// Success.jsx (vereinfachte Version ohne PDF-Logik)

import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import Confetti from "react-confetti";
import { useInsertName } from "./utils/helpers";
import { MonoButton, PaperBG } from "../kits";

const Success = () => {
  const name = useInsertName();
  const location = useLocation();
  const { formData, course } = location.state || {};
  const [windowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  return (
    <PaperBG>
      <div className="container mx-auto text-center py-12">
        <Confetti
          mode="boom"
          width={windowDimensions.width}
          height={windowDimensions.height}
          numberOfPieces={300}
          colors={["#ff577f", "#ff884b"]}
        />

        <p className="text-sm text-gray-700 mb-6">
          Vielen Dank für Deine Anmeldung {" "}
          <span className="text-orange-50 text-xl font-semibold">{name}</span>.
          <br />
          Deine Anmeldebestätigung wurde erfolgreich übermittelt.
        </p>

        <div className="flex justify-center mb-6">
          <video
            src="/videos/success-video.mp4"
            controls
            autoPlay
            muted
            className="w-full max-w-lg rounded-lg shadow-lg"
          ></video>
        </div>

        <div className="flex flex-col items-center space-y-4 w-full max-w-xs mx-auto">
          <Link to="/" className="w-full">
            <MonoButton className="w-full py-3 px-6 text-xs rounded transition duration-300">
              Zurück zur Startseite
            </MonoButton>
          </Link>
        </div>
      </div>
    </PaperBG>
  );
};

export default Success;